var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { outlinedInputClasses } from '@mui/material/OutlinedInput';
export var createMuiOutlinedInputOverrides = function (_a) {
    var _b, _c, _d, _e;
    var spacing = _a.spacing, transitions = _a.transitions, mixins = _a.mixins, tokens = _a.tokens;
    return {
        defaultProps: {
            color: 'primary',
            fullWidth: false,
            notched: false,
        },
        styleOverrides: {
            root: (_b = {
                    backgroundColor: tokens.color_bg_input
                },
                _b["& .".concat(outlinedInputClasses.notchedOutline)] = {
                    borderColor: tokens.color_border_input,
                },
                _b["&.".concat(outlinedInputClasses.disabled)] = (_c = {},
                    _c["& .".concat(outlinedInputClasses.notchedOutline, ", &:hover .").concat(outlinedInputClasses.notchedOutline)] = {
                        borderColor: tokens.color_border_input_disabled,
                    },
                    _c["&.".concat(outlinedInputClasses.error, " .").concat(outlinedInputClasses.notchedOutline)] = {
                        borderColor: tokens.color_border_state_danger,
                    },
                    _c),
                _b["&:hover .".concat(outlinedInputClasses.notchedOutline)] = {
                    borderColor: tokens.color_border_input_hover,
                },
                _b["&.".concat(outlinedInputClasses.focused, " .").concat(outlinedInputClasses.notchedOutline)] = __assign({ borderWidth: 2, borderColor: tokens.color_border_focus_bold }, mixins.focusRing()),
                _b["&.".concat(outlinedInputClasses.focused, ":hover .").concat(outlinedInputClasses.notchedOutline)] = __assign({ borderColor: tokens.color_border_focus_bold }, mixins.focusRing()),
                _b["&.".concat(outlinedInputClasses.error, " .").concat(outlinedInputClasses.notchedOutline)] = {
                    borderColor: tokens.color_border_state_danger,
                    borderWidth: 2,
                },
                _b["&.".concat(outlinedInputClasses.error, "&.").concat(outlinedInputClasses.focused, " .").concat(outlinedInputClasses.notchedOutline)] = __assign({ borderColor: tokens.color_border_state_danger }, mixins.focusRing({ color: tokens.color_border_focus_state_danger })),
                _b),
            notchedOutline: {
                top: 0,
                transition: transitions.create(['box-shadow', 'border-color', 'border-width'], {
                    duration: transitions.duration.shortest,
                }),
                '& legend': {
                    display: 'none',
                },
            },
            input: {
                padding: spacing(1.125, 2),
            },
            multiline: (_d = {
                    padding: 0
                },
                _d["&.".concat(outlinedInputClasses.adornedEnd)] = {
                    // resetting the default
                    paddingRight: 14,
                },
                _d),
            inputMultiline: (_e = {
                    padding: spacing(1, 2)
                },
                _e["&.".concat(outlinedInputClasses.inputAdornedEnd)] = {
                    // resetting the default
                    paddingRight: spacing(1),
                },
                _e),
            inputSizeSmall: {
                paddingTop: spacing(0.75),
                paddingBottom: spacing(0.75),
                paddingLeft: spacing(1.5),
                paddingRight: spacing(1.5),
                "&[type='number']": {
                    paddingRight: spacing(0.5),
                },
            },
            inputAdornedStart: {
                paddingLeft: 0,
            },
        },
    };
};
